const actionTypeIdentifier = '772257E0-8FE7-43B5-B3E7-8FB88149D6E5'

export const getManageUserComments = `GET-MANAGE-USER-COMMENTS-${actionTypeIdentifier}`;
export const setManageUserError = `SET-MANAGE-USER-ERROR-${actionTypeIdentifier}`;
export const insertManageUserComment = `INSERT-MANAGE-USER-COMMENTS-${actionTypeIdentifier}`;
export const resetManageUserComments = `RESET-MANAGE-USER-COMMENTS-${actionTypeIdentifier}`;
